import { Component, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { HourglassService } from 'src/app/services/hourglass.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-tab-help',
  templateUrl: './tab-help.component.html',
  styleUrls: ['../hourglass.component.css']
})
export class TabHelpComponent implements OnInit {
  token!: string;
  dropdownSettings = {};
  dropdownList:any[] = [];
  selectedItems: any[] = [];
  errorMsg = "";
  helpAsset = {
    id: "",
    type:"loom_video",
    mode:"add",
    url: "",
    title: "",
    description: "",
    active: 1,
    tags:[]
  };
  helpFilters = {
    tags:[],
    active:-1
  }
  isContentLoaded = false;
  listContent: any[] = [];
  listContentTags: any[] = [];
  showModal = "none";
  userID: any = sessionStorage.getItem('wOSImpersonate') || sessionStorage.getItem('wOSAuthUser') || "";
  authUser: any = sessionStorage.getItem('wOSAuthUser');
  authAdmin: any = sessionStorage.getItem('wOSAdmin');
  impersonatedUser: any = this.userID;
  
  constructor(
    private hourglassService: HourglassService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    const user: any = sessionStorage.getItem("wOSUser");
    this.token = JSON.parse(user).stsTokenManager.accessToken;
    const i = 0;
    
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'tag_pretty',
      enableCheckAll:false,
      //selectAllText: 'Select All',
      //unSelectAllText: 'UnSelect All',
      itemsShowLimit: 5,
      allowSearchFilter: true
    };
  }

  onItemSelect(item: any) {
    console.log(item);
  }
  onSelectAll(items: any) {
    console.log(items);
  }

  loadHelpContent(): void {
    if (!this.isContentLoaded) {
      const filters = { "active": 1 }
      this.hourglassService.getTimeEntryUxData(this.userID, 'all', filters,this.token).then(
        r => {
          this.listContent = r.helpdata;
          this.listContentTags = r.contenttags;
          this.dropdownList = this.listContentTags;
          this.selectedItems = [];

          this.listContent.forEach((row) => {
            row.content_url = this.sanitizer.bypassSecurityTrustResourceUrl(row.content_url);
          })
          this.isContentLoaded = true;
          setTimeout(() => {
            
            $('#contentTags').trigger('chosen:updated')
          },500)
        }
      )
    }
  }

  addContent(): void {
    this.clearHelpAsset();
    this.toggleModal('show');
  }

  toggleModal(mode: string) {
    const icon = '<i class="fas fa-fw fa-lg fa-plus-square me-2"></i>'
    $('.modal-title').html(icon + ((this.helpAsset.mode == 'add') ? 'Add' : 'Edit') + ' Content');
    this.showModal = (mode == 'show') ? "show" : "hide";
    ($('#contentModal') as any).modal(this.showModal);
  }

  clearHelpAsset(): void {
    this.helpAsset.mode = "add";
    this.helpAsset.id = "";
    this.helpAsset.url = "";
    this.helpAsset.title = "";
    this.helpAsset.description = "";
    this.helpAsset.active = 1;
    setTimeout(() => {
      $('#helpURL').trigger('focus')
    })
    
  }

  editHelpAsset(fileid: string): void {
    const asset = this.listContent.find(el => el.id == fileid);

    this.helpAsset.mode = "edit";
    this.helpAsset.id = asset.id;
    this.helpAsset.url = asset.content_url.changingThisBreaksApplicationSecurity;
    this.helpAsset.title = asset.title;
    this.helpAsset.description = asset.description 
    this.helpAsset.active = asset.active
    this.toggleModal('show');
  }

  clearError(): void {
    setTimeout(() => {
      this.errorMsg = ""
    }, 3500);
  }

  trackByFn(index: any, record: any) {
    return record.id
  }
}
